import {Avatar} from 'shells/avatar/avatar';
import {InfoIconWrapper} from 'shells/info-icon-wrapper/info-icon-wrapper';
import {PrimaryIconWrapper} from 'shells/primary-icon-wrapper/primary-icon-wrapper';
import {RowIcon} from 'shells/row/row-icon';

import {useValidatedAvatarUrl} from '../../../core/hooks/use-validated-avatar-url';

import type {ApiEntity, HoverviewOrientation} from './types';

type Props = {
    avatarUrl: string | null | undefined;
    entityName: ApiEntity;
    isHovered: boolean;
    entityId: string;
    parentEntityName: ApiEntity;
    isPrimary?: boolean | null | undefined;
    isParent?: boolean;
    orientationOverride?: HoverviewOrientation;
};

/**
 * A component that hooks into our previous jQuery hoverview system by setting
 * the apprporiate classes and data attributes.
 */
export function HoverableEntityAvatar(props: Props) {
    const avatarUrlValidated = useValidatedAvatarUrl(props.avatarUrl);

    const containerClassName =
        props.entityName === 'Accounts'
            ? 'react-account-hoverview-card'
            : 'react-contact-hoverview-card';

    const hoverviewClassName =
        props.entityName === 'Accounts'
            ? 'react-account-hoverview-icon'
            : 'react-contact-hoverview-icon';

    const rowIconType = props.isParent
        ? 'parent-account'
        : props.entityName === 'Accounts'
        ? 'accounts'
        : 'contacts';

    const avatarContent = avatarUrlValidated ? (
        <Avatar
            avatarUrl={avatarUrlValidated}
            size={32}
            circular={false}
            hasBorderRadius={true}
            displayBlock={true}
        />
    ) : (
        <RowIcon type={rowIconType} />
    );

    const IconWrapper = props.isPrimary && !props.isHovered ? PrimaryIconWrapper : InfoIconWrapper;
    const content = (
        <IconWrapper isHidden={props.isPrimary ? false : !props.isHovered}>
            {avatarContent}
        </IconWrapper>
    );

    return (
        <div
            className={containerClassName}
            data-entity-name={props.entityName}
            data-entity-id={props.entityId}
            data-parent-entity-name={props.parentEntityName}
            data-orientation-override={props.orientationOverride}
        >
            <div className={hoverviewClassName}>{content}</div>
        </div>
    );
}
